
class ProductCardForm extends HTMLElement {
  constructor() {
    super();

    this.productCard = this.closest('.product-card');
    this.form = this.querySelector("form");
    this.button = this.form.querySelector('button[name="add"]');
    this.form.addEventListener("submit", this.onSubmit.bind(this));
    this.quickViewContent = this.closest(".quick-view-content");

    this.handleVariantSelector();
    this.handleOptionsSelector();
  }

  async onSubmit(event) {
    event.preventDefault();

    const freeGifts = this.closest("sticky-atc") ? document.querySelector("free-gifts") : null;
    if (freeGifts && !freeGifts.areSelectionsComplete()) {
      freeGifts.focusIncomplete();
      freeGifts.syncAtcButtons();
      return;
    }

    this.button.classList.add("loading");
    this.button.disabled = true;
    this.button.setAttribute("aria-busy", "true");

    const formData = new FormData(this.form);

    // Sticky ATC on the product page should include free gifts with the main product.
    if (freeGifts) {
      freeGifts.applyToFormData?.(formData);
    }

    await document.querySelector("cart-component").add(formData);

    this.button.classList.remove("loading");
    this.button.disabled = false;
    this.button.setAttribute("aria-busy", "false");
    freeGifts?.syncAtcButtons?.();
  }

  handleVariantSelector() {
    const selector = this.querySelector("select[name='id']");
    if (!selector) return;
    
    selector.addEventListener("change", () => {
      const selectedOption = selector.options[selector.selectedIndex];
      const variantImage = selectedOption.dataset.variantImage;

      // Require-selection mode: enable the add-to-cart button only once a real
      // variant is picked (the placeholder option has an empty value).
      if (this.button) {
        if (selector.value) {
          this.button.disabled = false;
          if (this.button.dataset.textAdd) this.button.textContent = this.button.dataset.textAdd;
        } else {
          this.button.disabled = true;
          if (this.button.dataset.textChoose) this.button.textContent = this.button.dataset.textChoose;
        }
      }

      if (this.productCard) {
        if (variantImage.length) {
          this.productCard.querySelector('.img-wrapper img').src = variantImage;
        }

        this.productCard.querySelectorAll('input[name*="color-swatch"]').forEach((input) => {
          if (selectedOption.innerText.includes(input.value)) {
            input.checked = true;
          } else {
            input.checked = false;
          }
        });

        this.appendVariantIdToUrl(selector.value);
      }
    });
  }

  handleOptionsSelector() {
    const script = this.querySelector("[data-product-variants-json]");
    if (!script) return;

    const variantsData = JSON.parse(script.textContent);

    this.querySelectorAll('select[name*="option"]').forEach((select) => {
      select.addEventListener("change", () => {

        const selectedOptions = Array.from(this.querySelectorAll('select[name*="option"]'))
          .map((s) => s.value)

        const selectedVariant = variantsData.find((variant) => JSON.stringify(variant.options) === JSON.stringify(selectedOptions));

        const atcBtn = this.querySelector("button[name='add']");

        if (selectedVariant) {
          this.querySelector('[name="id"]').value = selectedVariant.id;

          atcBtn.textContent = selectedVariant.available ? atcBtn.dataset.textAdd : atcBtn.dataset.textSoldOut;
          atcBtn.disabled = !selectedVariant.available;
          
          let priceContainer

          if (this.productCard) {
            priceContainer = this.productCard.querySelector(".price");
          } else if (this.quickViewContent) {
            priceContainer = this.quickViewContent.querySelector(".price");
          }

          if (priceContainer) {
            priceContainer.setAttribute("data-has-price-compare", selectedVariant.compare_at_price > selectedVariant.price);
            priceContainer.setAttribute("data-price-varies", false);

            priceContainer.querySelectorAll("[data-compare-price]").forEach((elem) => {
              elem.textContent = window.Shopify.formatMoney(selectedVariant.compare_at_price);
            });

            priceContainer.querySelectorAll("[data-price]").forEach((elem) => {
              elem.textContent = window.Shopify.formatMoney(selectedVariant.price);
            });
          }
          
          const variantImage = selectedVariant.featured_image ? selectedVariant.featured_image.src : null;
          
          if (variantImage) {
            if (this.productCard) {
              const productImage = this.productCard.querySelector(".img-wrapper img");
              productImage.src = window.Shopify.resizeImage(variantImage, `${this.getVariantImageSize().width}x${this.getVariantImageSize().height}`, "center");
            } else if (this.quickViewContent) {
              let index =  0

              if (selectedVariant.featured_image) {
                index = selectedVariant.featured_image.position - 1;
              }

              const slideshow = this.quickViewContent.querySelector("slideshow-component");

              if (slideshow) {
                slideshow.go(index);
              }
            }
          }

          this.querySelectorAll('input[name*="color-swatch"]').forEach((input) => {
            if (selectedOptions.includes(input.value)) {
              input.checked = true;
            } else {
              input.checked = false;
            }
          });
        } else {
          atcBtn.textContent = atcBtn.dataset.textUnavailable;
          atcBtn.disabled = true;
        }
      })
    })
  }

  getVariantImageSize() {
    let imgWidth, imgHeight;

    switch (this.dataset.imgRatio) {
      case "adapt":
        imgWidth = 480;
        imgHeight = '';
        break;
      case "square":
        imgWidth = 480;
        imgHeight = 480;
        break;
      case "portrait":
        imgWidth = 480
        imgHeight = Math.round(480 * 4 / 3);
        break;
    }
    
    return { width: imgWidth, height: imgHeight };
  }

  appendVariantIdToUrl(variantId) {
    const link = this.closest('.product-card').querySelector(".product-card-link");
    if (!link) return;

    const url = new URL(link.href);
    url.searchParams.set("variant", variantId);
    link.href = url.toString();
  }
}
customElements.define("product-card-form", ProductCardForm);

class ProductCardColorSwatches extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('input[name*="color-swatch"]').forEach((input) => {
      input.addEventListener("change", () => {
        this.appendVariantIdToUrl(input.dataset.variantId);
  
        const productCard = this.closest('.product-card');

        if (productCard) {
          const variantImage = (input.dataset.variantImage || "").trim();
          if (variantImage) {
            const productImage = productCard.querySelector(".img-wrapper img");
            if (productImage) {
              productImage.src = variantImage;
            }
          }

          const variantInput = productCard.querySelector(".shopify-product-form [name='id']");
          if (variantInput) {
            variantInput.value = input.dataset.variantId;
          }
    
          const colorOption = productCard.querySelector(`.shopify-product-form select[data-option-name*="${input.dataset.optionName}"]`);

          if (colorOption) {
            colorOption.value = input.value;
          }
        }
      });
    });
  }

  appendVariantIdToUrl(variantId) {
    const link = this.closest('.product-card').querySelector(".product-card-link");
    if (!link) return;

    const url = new URL(link.href);
    url.searchParams.set("variant", variantId);
    link.href = url.toString();
  }
}
customElements.define("product-card-color-swatches", ProductCardColorSwatches);

document.addEventListener("pointerover", onProductCardThumb);
document.addEventListener("click", onProductCardThumb);
document.addEventListener("keydown", onProductCardThumbKey);

function applyProductCardThumb(btn) {
  const card = btn.closest(".product-card");
  if (!card) return;

  const variantImage = (btn.dataset.variantImage || "").trim();
  if (variantImage) {
    const productImage = card.querySelector(".img-wrapper img");
    if (productImage) productImage.src = variantImage;
  }

  card.querySelectorAll("[data-product-card-thumb]").forEach((el) => {
    const selected = el === btn;
    el.classList.toggle("is-selected", selected);
    el.setAttribute("aria-pressed", selected ? "true" : "false");
  });

  const variantId = btn.dataset.variantId;
  if (variantId) {
    const variantInput = card.querySelector(".shopify-product-form [name='id']");
    if (variantInput) variantInput.value = variantId;

    const link = card.querySelector(".product-card-link");
    if (link) {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set("variant", variantId);
      link.href = url.toString();
    }
  }
}

function onProductCardThumb(event) {
  const btn = event.target.closest("[data-product-card-thumb]");
  if (!btn) return;
  if (event.type === "click") event.preventDefault();
  applyProductCardThumb(btn);
}

function onProductCardThumbKey(event) {
  if (event.key !== "Enter" && event.key !== " ") return;
  const btn = event.target.closest("[data-product-card-thumb]");
  if (!btn) return;
  event.preventDefault();
  applyProductCardThumb(btn);
}

class SlideshowComponent extends HTMLElement {
  constructor() {
    super();

    this.slides = this.querySelectorAll(".slideshow-slide");
    this.currentIndex = 0;
    this.interval = null;
    this.lcpReady = false;

    this.handleSlidesAccessibility();
    this.animateOnScroll();
    this.handleFullHeight();
    this.handleEditor();

    if (this.dataset.lcpDefer === "true") {
      this.initLcpDefer();
      return;
    }

    this.initInteractive();
  }

  initInteractive() {
    this.handleControls();
    this.handleAutoplay();
    this.handleTouch();
    this.handleKeyboard();
  }

  initLcpDefer() {
    this.handleControls();
    this.scheduleLcpActivate();
  }

  scheduleLcpActivate() {
    const firstSlide = this.slides[0];
    const firstMedia = firstSlide
      ? firstSlide.querySelector("img[src], video")
      : null;
    let settled = false;

    const finish = () => {
      if (settled) return;
      settled = true;
      this.activateLcp();
    };

    const fallbackId = setTimeout(finish, 2000);

    if (!firstMedia) {
      clearTimeout(fallbackId);
      finish();
      return;
    }

    if (firstMedia.tagName === "IMG") {
      if (firstMedia.complete && firstMedia.naturalWidth > 0) {
        clearTimeout(fallbackId);
        if (typeof firstMedia.decode === "function") {
          firstMedia.decode().catch(() => {}).finally(finish);
        } else {
          finish();
        }
        return;
      }

      firstMedia.addEventListener(
        "load",
        () => {
          clearTimeout(fallbackId);
          if (typeof firstMedia.decode === "function") {
            firstMedia.decode().catch(() => {}).finally(finish);
          } else {
            finish();
          }
        },
        { once: true },
      );
      firstMedia.addEventListener(
        "error",
        () => {
          clearTimeout(fallbackId);
          finish();
        },
        { once: true },
      );
      return;
    }

    clearTimeout(fallbackId);
    finish();
  }

  activateLcp() {
    if (this.dataset.lcpDefer !== "true" || this.lcpReady) return;
    this.lcpReady = true;
    this.hydrateDeferredMedia();
    this.dataset.lcpReady = "true";
    this.handleAutoplay();
    this.handleTouch();
    this.handleKeyboard();
  }

  hydrateDeferredMedia() {
    this.querySelectorAll("source[data-srcset]").forEach((source) => {
      source.setAttribute("srcset", source.dataset.srcset);
      source.removeAttribute("data-srcset");
    });

    this.querySelectorAll("img[data-src]").forEach((img) => {
      img.setAttribute("src", img.dataset.src);
      img.removeAttribute("data-src");
    });

    this.querySelectorAll(".slideshow-slide .video-wrapper[data-video-autoplay='false']").forEach((wrapper) => {
      wrapper.dataset.videoAutoplay = "true";
    });
  }

  prev() {
    this.activateLcp();
    this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.update();
  }

  next() {
    this.activateLcp();
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    this.update();
  }

  go(index) {
    this.activateLcp();
    this.currentIndex = index;
    this.update();
  }

  update() {
    const offset = -this.currentIndex * 100;
    this.querySelector(".slideshow-track").style.transform = `translateX(${offset}%)`;

    this.slides.forEach((slide, index) => {
      slide.classList.toggle("active", index === this.currentIndex);
    });

    this.querySelectorAll(".slideshow-pagination[data-pagination-type='dots'] button").forEach((btn, i) => {
      btn.classList.toggle("active", i === this.currentIndex);
    });

    this.querySelectorAll(".slideshow-pagination[data-pagination-type='fraction'] span").forEach((elem) => {
      elem.textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
    });

    this.handleSlidesAccessibility();
  }

  handleControls() {
    this.querySelectorAll(".slideshow-control").forEach((btn) => {
      if (this.slides.length <= 1) {
        btn.disabled = true;
      }

      btn.addEventListener("click", () => {
        if (btn.name === "previous") {
          this.prev();
        } else if (btn.name === "next") {
          this.next();
        }
      });
    });

    this.querySelectorAll(".slideshow-pagination button").forEach((btn, index) => {
      btn.addEventListener("click", () => {
        this.go(index);
      });
    });
  }

  handleAutoplay() {
    if (!this.dataset.autoplay || this.dataset.autoplay === "0") return;

    const start = () => {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = setInterval(() => this.next(), Number(this.dataset.autoplay) * 1000);
      this.dataset.autoplayStopped = "false";
      this.querySelector(".slideshow-track").setAttribute("aria-live", "off");
    };

    const stop = () => {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
      this.dataset.autoplayStopped = "true";
      this.querySelector(".slideshow-track").setAttribute("aria-live", "polite");
    };

    // Exposed so disconnectedCallback can halt the timer when removed.
    this.stopAutoplay = stop;
    start();

    // Listeners are on the element itself, so they're GC'd with it — only the
    // interval needs explicit teardown.
    this.addEventListener("focusin", stop);
    this.addEventListener("focusout", start);
    this.addEventListener("mouseenter", stop);
    this.addEventListener("mouseleave", start);
    this.addEventListener("touchstart", stop, { passive: true });
    this.addEventListener("touchend", start);

    this.addEventListener("shopify:block:select", (e) => {
      if (e.target.closest(`[data-section-id="${this.dataset.sectionId}"]`)) stop();
    });
  }

  handleKeyboard() {
    this.addEventListener("keydown", (event) => {
      if (event.key === "ArrowLeft") this.prev();
      else if (event.key === "ArrowRight") this.next();
    });
  }

  handleTouch() {
    let startX = 0;
    let endX = 0;

    this.addEventListener("touchstart", (e) => {
      if (e.touches.length > 1) return;
      startX = e.touches[0].clientX;
    });

    this.addEventListener("touchend", (e) => {
      if (!startX || e.changedTouches.length > 1) return;
      endX = e.changedTouches[0].clientX;
      const swipeDistance = startX - endX;

      if (swipeDistance > 10) {
        this.next();
      } else if (swipeDistance < -10) {
        this.prev();
      }
    });
  }

  handleSlidesAccessibility() {
    this.slides.forEach((slide, i) => {
      if (i === this.currentIndex) {
        slide.removeAttribute("aria-hidden");
        slide.removeAttribute("tabindex");
        slide.querySelectorAll("a, button").forEach((el) => {
          el.removeAttribute("tabindex");
        });
      } else {
        slide.setAttribute("aria-hidden", "true");
        slide.setAttribute("tabindex", "-1");
        slide.querySelectorAll("a, button").forEach((el) => {
          el.setAttribute("tabindex", "-1");
        });
      }
    });
  }

  animateOnScroll() {
    const slides = this.querySelectorAll(".slideshow-slide");
    if (!slides.length || slides[0].dataset.overlayOpacity === undefined) return;
  
    let ticking = false;
  
    const updateOverlay = () => {
      if (this.clientHeight > window.innerHeight) return;

      const top = Math.round(this.getBoundingClientRect().top);
      const bottom = Math.round(this.getBoundingClientRect().bottom);
      const visibilityTop = Math.round(((window.innerHeight - top) / this.clientHeight) * 100);
      const visibilityBottom = Math.round((bottom / this.clientHeight) * 100);
  
      if ((visibilityTop > 0 && visibilityTop < 100) || (visibilityBottom > 0 && visibilityBottom < 100)) {
        slides.forEach((elem) => {
          const overlayOpacity = Number(elem.dataset.overlayOpacity);
          const visibility = visibilityTop > 0 && visibilityTop < 100 ? visibilityTop : visibilityBottom;
          const final = Math.round((100 - overlayOpacity) * (1 - visibility / 100) + overlayOpacity);
          elem.style.setProperty("--overlay-opacity", final + "%");
        });
      }
  
      ticking = false;
    };
  
    // Stored so it can be removed on disconnect (otherwise every slideshow —
    // including the ones quick-view rebuilds per variant — leaks a permanent
    // window scroll listener).
    this.onOverlayScroll = () => {
      if (!ticking) {
        requestAnimationFrame(updateOverlay);
        ticking = true;
      }
    };
    window.addEventListener("scroll", this.onOverlayScroll, { passive: true });
  }

  handleFullHeight() {
    const indicator = this.querySelector(".slideshow-full-height-indicator");
    if (!indicator) return;

    let fullHeightTicking = false;
    this.onFullHeightScroll = () => {
      if (fullHeightTicking) return;
      fullHeightTicking = true;
      requestAnimationFrame(() => {
        if (window.scrollY > 10) {
          indicator.classList.add("hide");
        } else {
          indicator.classList.remove("hide");
        }
        fullHeightTicking = false;
      });
    };
    window.addEventListener("scroll", this.onFullHeightScroll, { passive: true });
  }

  handleEditor() {
    // Only needed in the theme editor — skip the global listener on storefront.
    if (!(window.Shopify && window.Shopify.designMode)) return;

    this.onBlockSelect = (event) => {
      if (event.target.closest(`[data-section-id="${this.dataset.sectionId}"]`)) {
        this.go(Number(event.target.dataset.index));
      }
    };
    document.addEventListener("shopify:block:select", this.onBlockSelect);
  }

  disconnectedCallback() {
    clearInterval(this.autoplayInterval);
    if (this.onOverlayScroll) window.removeEventListener("scroll", this.onOverlayScroll);
    if (this.onFullHeightScroll) window.removeEventListener("scroll", this.onFullHeightScroll);
    if (this.onBlockSelect) document.removeEventListener("shopify:block:select", this.onBlockSelect);
  }
}
customElements.define("slideshow-component", SlideshowComponent);

class DialogComponent extends HTMLElement {
  constructor() {
    super();

    this.dialog = this.closest("dialog");
    this.triggerElement = null;

    this.handleOpen();
    this.handleClose();
    this.handleObserver();
    this.handleAccessibility();
  }

  handleOpen() {
    this.onBodyOpenClick = (event) => {
      const button = event.target.closest("[data-open-dialog]");
      if (!button) return;

      event.preventDefault();
      const dialogId = button.dataset.openDialog;

      if (dialogId == this.dialog.id) {
        this.triggerElement = button;
        this.dialog.showModal();
      }
    };
    document.body.addEventListener("click", this.onBodyOpenClick);

    if (this.dialog && typeof this.dialog.showModal === "function") {
      const originalShowModal = this.dialog.showModal.bind(this.dialog);
      this.dialog.showModal = (...args) => {
        if (!this.triggerElement) {
          const active = document.activeElement;
          if (active && active !== document.body && !this.dialog.contains(active)) {
            this.triggerElement = active;
          }
        }
        return originalShowModal(...args);
      };
    }
  }

  handleClose() {
    const close = () => {
      this.dialog.classList.add("closing");
      this.dialog.addEventListener(
        "transitionend",
        () => {
          this.dialog.classList.remove("closing");
          this.dialog.close();
        },
        { once: true },
      );
    };

    this.onBodyCloseClick = (event) => {
      const button = event.target.closest("[data-dialog-close]");
      if (button && this.contains(button)) {
        close();
      }
    };
    document.body.addEventListener("click", this.onBodyCloseClick);

    this.onBackdropClick = (event) => {
      const path = event.composedPath();
      const inner = this.dialog.querySelector(".dialog-inner");

      if (!path.includes(inner)) {
        close();
      }
    };
    this.dialog.addEventListener("click", this.onBackdropClick);
  }

  handleObserver() {
    this.observer = new MutationObserver(() => {
      if (this.dialog.open) {
        document.body.style.overflow = "hidden";
        window.dispatchEvent(
          new CustomEvent("dialog:open", {
            detail: {
              dialog: this.dialog,
              triggerElement: this.triggerElement,
            },
          }),
        );
      } else {
        document.body.style.overflow = "";
        window.dispatchEvent(
          new CustomEvent("dialog:close", {
            detail: {
              dialog: this.dialog,
            },
          }),
        );
      }
    });

    this.observer.observe(this.dialog, {
      attributes: true,
      attributeFilter: ["open"],
    });
  }

  handleAccessibility() {
    if (!this.dialog) return;

    const focusableSelector =
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const getFocusable = () =>
      Array.from(this.dialog.querySelectorAll(focusableSelector)).filter((el) => {
        if (el.closest("[hidden]")) return false;
        if (el.getAttribute("aria-hidden") === "true") return false;
        return true;
      });

    this.onDialogKeydown = (event) => {
      if (!this.dialog.open || event.key !== "Tab") return;

      const nodes = getFocusable();
      if (!nodes.length) {
        event.preventDefault();
        this.dialog.focus();
        return;
      }

      const first = nodes[0];
      const last = nodes[nodes.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === this.dialog)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    this.dialog.addEventListener("keydown", this.onDialogKeydown);

    this.onDialogClose = () => {
      const trigger = this.triggerElement;
      this.triggerElement = null;
      if (trigger && document.contains(trigger) && typeof trigger.focus === "function") {
        requestAnimationFrame(() => trigger.focus());
      }
    };
    this.dialog.addEventListener("close", this.onDialogClose);
  }

  disconnectedCallback() {
    document.body.removeEventListener("click", this.onBodyOpenClick);
    document.body.removeEventListener("click", this.onBodyCloseClick);
    this.dialog?.removeEventListener("click", this.onBackdropClick);
    this.dialog?.removeEventListener("keydown", this.onDialogKeydown);
    this.dialog?.removeEventListener("close", this.onDialogClose);
    this.observer?.disconnect();
  }
}
customElements.define("dialog-component", DialogComponent);

class DropdownComponent extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector(".dropdown-btn");
    this.content = this.querySelector(".dropdown-content");

    this.button.addEventListener("click", (event) => {
      event.preventDefault();
      this.toggle();
    });

    this.handleAccessibility();
  }

  open() {
    this.button.setAttribute("aria-expanded", true);
    this.button.dispatchEvent(new CustomEvent("dropdown:open", { bubbles: true }));
    this.content.hidden = false;

    if (window.innerWidth - this.button.getBoundingClientRect().right < this.content.offsetWidth) {
      this.content.style.left = "auto";
      this.content.style.right = "0";
    } else {
      this.content.style.left = "";
      this.content.style.right = "";
    }
  }

  close() {
    if (this.button.getAttribute("aria-expanded") === "false") return;
    this.button.setAttribute("aria-expanded", false);
    this.button.dispatchEvent(new CustomEvent("dropdown:close", { bubbles: true }));
    this.content.hidden = true;
  }

  toggle() {
    const isExpanded = this.button.getAttribute("aria-expanded") === "true";
    isExpanded ? this.close() : this.open();
  }

  handleAccessibility() {
    this.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.close();
        this.button.focus();
      }
    });

    this.addEventListener("focusout", (event) => {
      if (event.relatedTarget && !this.contains(event.relatedTarget) && !event.relatedTarget.closest("dialog")) {
        this.close();
      }
    });

    // Global outside-click listener — stored so it's removed on disconnect.
    this.onDocumentClick = (event) => {
      if (!this.contains(event.target) && !event.target.closest("dialog")) {
        this.close();
      }
    };
    document.addEventListener("click", this.onDocumentClick);
  }

  disconnectedCallback() {
    if (this.onDocumentClick) document.removeEventListener("click", this.onDocumentClick);
  }
}
customElements.define("dropdown-component", DropdownComponent);

class CollapseComponent extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.content = this.querySelector(".collapse-content");

    this.onSummaryClick = this.toggle.bind(this);
    this.onResize = this.fixHeight.bind(this);
    this.onDialogOpen = this.handleDialogOpen.bind(this);

    this.handleNestedChange = this.handleNestedChange.bind(this);
    this.handleInnerTransitionEnd = this.handleInnerTransitionEnd.bind(this);

    this.summary?.addEventListener("click", this.onSummaryClick);
    window.addEventListener("resize", this.onResize);
    window.addEventListener("dialog:open", this.onDialogOpen);

    this.addEventListener("collapse:open", this.handleNestedChange);
    this.addEventListener("collapse:close", this.handleNestedChange);
    this.content?.addEventListener("transitionend", this.handleInnerTransitionEnd);

    this.observer = new MutationObserver(() => {
      this.fixHeight();
    });

    if (this.content) {
      this.observer.observe(this.content, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    this.fixHeight();
    this.syncExpanded();
  }

  handleDialogOpen() {
    if (this.closest(".dialog") && this.details?.hasAttribute("open") && this.content) {
      this.content.style.height = `${this.content.scrollHeight}px`;
    }
  }

  open() {
    if (!this.details || !this.content) return;
    this.details.open = true;
    this.content.style.height = `${this.content.scrollHeight}px`;
    this.syncExpanded();
    this.dispatchEvent(new CustomEvent("collapse:open", { bubbles: true }));
  }

  close() {
    if (!this.details || !this.content) return;
    this.content.style.height = "0px";
    this.summary?.setAttribute("aria-expanded", "false");

    this.content.addEventListener(
      "transitionend",
      () => {
        this.content.style.height = "";
        this.details.removeAttribute("open");
      },
      { once: true },
    );

    this.dispatchEvent(new CustomEvent("collapse:close", { bubbles: true }));
  }

  toggle(event) {
    event.preventDefault();
    const isOpen = this.details?.hasAttribute("open");
    isOpen ? this.close() : this.open();
  }

  syncExpanded() {
    if (!this.summary || !this.details) return;
    this.summary.setAttribute("aria-expanded", this.details.hasAttribute("open") ? "true" : "false");
  }

  fixHeight() {
    if (!this.details || !this.content) return;

    if (this.details.hasAttribute("open")) {
      this.content.style.height = "auto";
      setTimeout(() => {
        if (this.content.scrollHeight > 0) {
          this.content.style.height = `${this.content.scrollHeight}px`;
        }
      }, 100);
    }
  }

  handleNestedChange(event) {
    if (event.target === this) return;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.fixHeight());
    });
  }

  handleInnerTransitionEnd(event) {
    if (event.target !== this.content) return;
    this.fixHeight();
  }

  disconnectedCallback() {
    this.summary?.removeEventListener("click", this.onSummaryClick);
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("dialog:open", this.onDialogOpen);

    this.removeEventListener("collapse:open", this.handleNestedChange);
    this.removeEventListener("collapse:close", this.handleNestedChange);
    this.content?.removeEventListener("transitionend", this.handleInnerTransitionEnd);

    this.observer?.disconnect();
  }
}

customElements.define("collapse-component", CollapseComponent);

class LookBook extends HTMLElement {
  constructor() {
    super();
    this.points = Array.from(this.querySelectorAll(".lookbook-points-item button"));
    if (!this.points.length) return;

    this.points.forEach((btn, i) => {
      btn.setAttribute("tabindex", i === 0 ? "0" : "-1");
      if (i === 0) btn.setAttribute("aria-current", "true");
      btn.addEventListener("keydown", (event) => this.onKeydown(event, i));
      btn.addEventListener("click", () => this.setActive(i));
    });
  }

  setActive(index) {
    this.points.forEach((btn, i) => {
      const isActive = i === index;
      btn.classList.toggle("active", isActive);
      btn.setAttribute("tabindex", isActive ? "0" : "-1");
      if (isActive) {
        btn.setAttribute("aria-current", "true");
      } else {
        btn.removeAttribute("aria-current");
      }
    });
  }

  onKeydown(event, index) {
    let next = null;
    if (event.key === "ArrowRight" || event.key === "ArrowDown") {
      next = (index + 1) % this.points.length;
    } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
      next = (index - 1 + this.points.length) % this.points.length;
    } else if (event.key === "Home") {
      next = 0;
    } else if (event.key === "End") {
      next = this.points.length - 1;
    }
    if (next === null) return;
    event.preventDefault();
    this.setActive(next);
    this.points[next].focus();
  }
}
customElements.define("look-book", LookBook);

class CountdownComponent extends HTMLElement {
  constructor() {
    super();

    const countdown = Number(this.dataset.countdown);

    if (isNaN(countdown)) {
      return;
    }

    this.myInterval = setInterval(() => {
      const now = new Date().getTime();
      const diff = countdown - now;
      this.update(diff);
    }, 1000);
  }

  update(diff) {
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    const daysElem = this.querySelector("[data-countdown-days]");
    const hoursElem = this.querySelector("[data-countdown-hours]");
    const minutesElem = this.querySelector("[data-countdown-minutes]");
    const secondsElem = this.querySelector("[data-countdown-seconds]");

    if (days > 0) {
      daysElem.textContent = days;
    } else {
      daysElem?.parentElement.remove();
    }

    if (hours > 0) {
      hoursElem.textContent = hours;
    } else {
      hoursElem?.parentElement.remove();
    }

    minutesElem.textContent = minutes;
    secondsElem.textContent = seconds;
    
    if (diff < 0) {
      clearInterval(this.myInterval);
      this.closest('[data-has-countdown]')?.setAttribute("data-has-countdown", "false");
      this.remove();
    }
  }

  disconnectedCallback() {
    clearInterval(this.myInterval);
  }
}
customElements.define("countdown-component", CountdownComponent);

class ShareComponent extends HTMLElement {
  constructor() {
    super();

    this.shareButton = this.querySelector(".btn-share");
    this.dropdownComponent = this.querySelector("dropdown-component");
    this.url = this.dataset.url || window.location.href;
    this.title = this.dataset.title || document.title;

    if (navigator.share) {
      this.shareButton.addEventListener("click", () => {
        navigator.share({
          title: this.title,
          url: this.url,
        });
      });
    } else {
      setTimeout(() => {
        this.shareButton.remove();
        this.dropdownComponent.hidden = false;

        const innerButton = this.dropdownComponent.querySelector(".dropdown-content .button");
        innerButton.addEventListener("click", () => {
          navigator.clipboard.writeText(this.url).then(() => {
            innerButton.textContent = innerButton.dataset.textCopied;
          });
        });
      }, 500);
    }
  }
}
customElements.define("share-component", ShareComponent);


class HeroBanner extends HTMLElement {
  constructor() {
    super();

    this.EFFECTS = new Set(["fade", "slide", "zoom", "reveal"]);
    this.SPEEDS = new Set(["fast", "normal", "slow"]);
    this.SPEED_MAP = {
      fast: { fade: 220, slide: 260, zoom: 300, reveal: 240 },
      normal: { fade: 320, slide: 360, zoom: 420, reveal: 320 },
      slow: { fade: 420, slide: 480, zoom: 560, reveal: 420 },
    };

    this.onNextClick = this.goNext.bind(this);
    this.onPrevClick = this.goPrev.bind(this);
    this.onTouchStart = this.handleTouchStart.bind(this);
    this.onTouchMove = this.handleTouchMove.bind(this);
    this.onTouchEnd = this.handleTouchEnd.bind(this);

    this.startX = 0;
    this.startY = 0;
    this.deltaX = 0;
    this.isSwiping = false;
    this.lastSwipeAt = 0;
    this.SWIPE_THRESHOLD = 40;
    this.SWIPE_COOLDOWN = 250;
  }

  connectedCallback() {
    if (this.dataset.sliderInit === "true") return;
    this.dataset.sliderInit = "true";

    this.slideWrapper = this.querySelector(".hero-banner__slide-wrapper");
    this.slideControls = this.querySelector(".hero-banner__slide-controls");
    this.prevButton = this.querySelector(".hero-banner__slide-controls-prev");
    this.nextButton = this.querySelector(".hero-banner__slide-controls-next");
    this.dotsWrap = this.querySelector(".hero-banner__dots");
    this.dots = Array.from(this.querySelectorAll(".hero-banner__dot"));

    if (!this.slideWrapper || !this.slideControls || !this.prevButton || !this.nextButton) return;

    this.slides = Array.from(this.slideWrapper.children);
    this.slides.forEach((slide, index) => {
      slide.dataset.slideIndex = String(index);
    });

    if (this.slides.length < 2) {
      this.slideControls.classList.remove("show");
      if (this.dotsWrap) this.dotsWrap.style.display = "none";
      return;
    }

    this.slideControls.classList.add("show");
    this.applySpeedVars();

    this.nextButton.addEventListener("click", this.onNextClick);
    this.prevButton.addEventListener("click", this.onPrevClick);

    this.dotHandlers = [];
    this.dots.forEach((dot) => {
      const handler = () => {
        const targetIndex = Number(dot.dataset.dotIndex);
        this.goToIndex(targetIndex);
      };
      this.dotHandlers.push({ dot, handler });
      dot.addEventListener("click", handler);
    });

    this.slideWrapper.addEventListener("touchstart", this.onTouchStart, { passive: true });
    this.slideWrapper.addEventListener("touchmove", this.onTouchMove, { passive: true });
    this.slideWrapper.addEventListener("touchend", this.onTouchEnd, { passive: true });

    this.updateDots();
  }

  disconnectedCallback() {
    this.nextButton?.removeEventListener("click", this.onNextClick);
    this.prevButton?.removeEventListener("click", this.onPrevClick);

    this.dotHandlers?.forEach(({ dot, handler }) => dot.removeEventListener("click", handler));

    this.slideWrapper?.removeEventListener("touchstart", this.onTouchStart);
    this.slideWrapper?.removeEventListener("touchmove", this.onTouchMove);
    this.slideWrapper?.removeEventListener("touchend", this.onTouchEnd);
  }

  getEffect() {
    const v = this.dataset.animationEffect;
    return this.EFFECTS.has(v) ? v : "fade";
  }

  getSpeed() {
    const v = this.dataset.animationSpeed;
    return this.SPEEDS.has(v) ? v : "normal";
  }

  applySpeedVars() {
    const cfg = this.SPEED_MAP[this.getSpeed()];
    this.style.setProperty("--hero-fade-ms", `${cfg.fade}ms`);
    this.style.setProperty("--hero-slide-ms", `${cfg.slide}ms`);
    this.style.setProperty("--hero-zoom-ms", `${cfg.zoom}ms`);
    this.style.setProperty("--hero-reveal-ms", `${cfg.reveal}ms`);
  }

  resetAnimationClasses(el) {
    el.classList.remove("anim-fade", "anim-slide-next", "anim-slide-prev", "anim-zoom", "anim-reveal");
  }

  animateCurrentSlide(direction) {
    const currentSlide = this.slideWrapper.firstElementChild;
    if (!currentSlide) return;

    this.applySpeedVars();
    const effect = this.getEffect();

    this.resetAnimationClasses(currentSlide);
    currentSlide.offsetHeight;

    if (effect === "fade") currentSlide.classList.add("anim-fade");
    else if (effect === "slide") currentSlide.classList.add(direction === "prev" ? "anim-slide-prev" : "anim-slide-next");
    else if (effect === "zoom") currentSlide.classList.add("anim-zoom");
    else if (effect === "reveal") currentSlide.classList.add("anim-reveal");

    currentSlide.addEventListener("animationend", () => this.resetAnimationClasses(currentSlide), { once: true });
  }

  updateDots() {
    if (!this.dots.length) return;

    const currentSlide = this.slideWrapper.firstElementChild;
    const activeIndex = Number(currentSlide?.dataset.slideIndex || 0);

    this.dots.forEach((dot, index) => {
      const isActive = index === activeIndex;
      dot.classList.toggle("is-active", isActive);
      dot.setAttribute("aria-current", isActive ? "true" : "false");
    });
  }

  goNext() {
    this.slideWrapper.appendChild(this.slideWrapper.firstElementChild);
    this.animateCurrentSlide("next");
    this.updateDots();
  }

  goPrev() {
    this.slideWrapper.prepend(this.slideWrapper.lastElementChild);
    this.animateCurrentSlide("prev");
    this.updateDots();
  }

  goToIndex(targetIndex) {
    let guard = 0;
    while (guard < this.slides.length) {
      const currentIndex = Number(this.slideWrapper.firstElementChild?.dataset.slideIndex || 0);
      if (currentIndex === targetIndex) break;
      this.slideWrapper.appendChild(this.slideWrapper.firstElementChild);
      guard += 1;
    }
    this.animateCurrentSlide("next");
    this.updateDots();
  }

  handleTouchStart(e) {
    const touch = e.changedTouches[0];
    this.startX = touch.clientX;
    this.startY = touch.clientY;
    this.deltaX = 0;
    this.isSwiping = false;
  }

  handleTouchMove(e) {
    const touch = e.changedTouches[0];
    const dx = touch.clientX - this.startX;
    const dy = touch.clientY - this.startY;

    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) {
      this.isSwiping = true;
      this.deltaX = dx;
    }
  }

  handleTouchEnd() {
    if (!this.isSwiping) return;

    const now = Date.now();
    if (now - this.lastSwipeAt < this.SWIPE_COOLDOWN) return;

    if (Math.abs(this.deltaX) >= this.SWIPE_THRESHOLD) {
      if (this.deltaX < 0) this.goNext();
      else this.goPrev();
      this.lastSwipeAt = now;
    }
  }
}

if (!customElements.get("hero-banner")) {
  customElements.define("hero-banner", HeroBanner);
}


class CollectionTabs extends HTMLElement {
  constructor() {
    super();

    this.onTabClick = this.onTabClick.bind(this);
    this.onTabKeydown = this.onTabKeydown.bind(this);
    this.onBlockSelect = this.onBlockSelect.bind(this);
  }

  connectedCallback() {
    if (this.dataset.initialized === "true") return;
    this.dataset.initialized = "true";

    this.tabs = Array.from(this.querySelectorAll("[data-tab-trigger]"));
    this.panels = Array.from(this.querySelectorAll("[data-tab-panel]"));
    if (!this.tabs.length || !this.panels.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener("click", this.onTabClick);
      tab.addEventListener("keydown", this.onTabKeydown);
    });

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener("shopify:block:select", this.onBlockSelect);
    }
  }

  disconnectedCallback() {
    this.tabs?.forEach((tab) => {
      tab.removeEventListener("click", this.onTabClick);
      tab.removeEventListener("keydown", this.onTabKeydown);
    });

    if (window.Shopify && window.Shopify.designMode) {
      document.removeEventListener("shopify:block:select", this.onBlockSelect);
    }
  }

  onTabClick(event) {
    const tab = event.currentTarget;
    const id = tab.dataset.tabTrigger;
    this.activateTab(id, true);
  }

  onTabKeydown(event) {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    if (currentIndex < 0) return;

    let nextIndex = null;

    if (event.key === "ArrowRight") nextIndex = (currentIndex + 1) % this.tabs.length;
    if (event.key === "ArrowLeft") nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === "Home") nextIndex = 0;
    if (event.key === "End") nextIndex = this.tabs.length - 1;

    if (nextIndex === null) return;

    event.preventDefault();
    const nextTab = this.tabs[nextIndex];
    this.activateTab(nextTab.dataset.tabTrigger, true);
  }

  onBlockSelect(event) {
    const blockEl = event.target;
    if (!blockEl || !this.contains(blockEl)) return;

    const tabTrigger = blockEl.dataset.tabTrigger || blockEl.dataset.tabPanel || blockEl.dataset.blockId;
    if (!tabTrigger) return;

    this.activateTab(tabTrigger, false);
  }

  activateTab(id, focusTab = false) {
    this.tabs.forEach((tab) => {
      const active = tab.dataset.tabTrigger === id;
      tab.classList.toggle("is-active", active);
      tab.setAttribute("aria-selected", active ? "true" : "false");
      tab.setAttribute("tabindex", active ? "0" : "-1");
      if (active && focusTab) tab.focus();
    });

    this.panels.forEach((panel) => {
      const active = panel.dataset.tabPanel === id;
      if (active) this.hydratePanel(panel);
      panel.classList.toggle("is-active", active);
      panel.hidden = !active;
    });

    // Recalculate carousel controls/pagination after panel swap.
    window.dispatchEvent(new Event("resize"));
  }

  // Inactive tabs render their carousel inside an inert <template> so ~120
  // off-screen product cards don't upgrade on initial load. Materialize the
  // markup (which upgrades the custom elements) the first time a tab is shown.
  hydratePanel(panel) {
    const template = panel.querySelector("template[data-tab-content]");
    if (!template) return;

    panel.insertBefore(template.content.cloneNode(true), template);
    template.remove();
  }
}
customElements.define("collection-tabs", CollectionTabs);


class BundleBox extends HTMLElement {
  constructor() {
    super();

    this.selectedItems = new Map();
    this.selectedCount = 0;
    this.limit = 0;

    this.onSubmit = this.onSubmit.bind(this);
  }

  connectedCallback() {
    if (this.dataset.initialized === "true") return;
    this.dataset.initialized = "true";

    this.section = this.closest(".bundle-box");
    if (!this.section) return;

    this.statusLabel = this.section.dataset.statusLabel || "products selected";

    this.items = Array.from(this.querySelectorAll(".bundle-box__item"));
    this.variantButtons = Array.from(this.querySelectorAll(".bundle-box__variant"));
    this.pickedList = this.querySelector(".bundle-box__picked-list");
    this.emptyState = this.querySelector(".bundle-box__empty");
    this.statusEl = this.querySelector(".bundle-box__status");
    this.form = this.querySelector(".bundle-box__form");
    this.variantInput = this.querySelector("[data-bundle-variant-input]");
    this.productsPropertyInput = this.querySelector("[data-bundle-products-property]");
    this.submitButton = this.querySelector(".bundle-box__submit-btn");

    this.bindVariantSwitch();
    this.bindProductCards();
    this.bindSubmit();

    const activeVariant =
      this.variantButtons.find((btn) => btn.classList.contains("is-active")) || this.variantButtons[0];
    if (activeVariant) this.activateVariant(activeVariant);

    this.updateUI();
  }

  disconnectedCallback() {
    if (this.form) this.form.removeEventListener("submit", this.onSubmit);
  }

  bindVariantSwitch() {
    this.variantButtons.forEach((btn) => {
      btn.addEventListener("click", () => this.activateVariant(btn));
    });
  }

  activateVariant(btn) {
    this.variantButtons.forEach((b) => b.classList.remove("is-active"));
    btn.classList.add("is-active");

    const nextLimit = Number(btn.dataset.limit || 0);
    this.limit = Number.isFinite(nextLimit) ? nextLimit : 0;

    if (this.variantInput) this.variantInput.value = btn.dataset.variantId || "";

    this.resetSelections();
  }

  resetSelections() {
    this.selectedItems.clear();
    this.selectedCount = 0;

    this.items.forEach((item) => {
      item.classList.remove("is-active");

      const qtyWrap = item.querySelector(".bundle-box__qty");
      const qtyValue = item.querySelector(".bundle-box__qty-value");
      const addBtn = item.querySelector(".bundle-box__add-btn");
      const plusBtn = item.querySelector('[data-action="plus"]');

      if (qtyWrap) qtyWrap.hidden = true;
      if (qtyValue) qtyValue.textContent = "1";
      if (addBtn && !addBtn.classList.contains("out-of-stock")) addBtn.disabled = false;
      if (plusBtn) plusBtn.disabled = false;

      // Sync dataset with currently selected native variant/title
      this.syncSelectedItemIdentity(item);
    });

    this.renderPickedList();
    this.updateUI();
  }

  bindProductCards() {
    this.items.forEach((item) => {
      const addBtn = item.querySelector(".bundle-box__add-btn");
      const qtyWrap = item.querySelector(".bundle-box__qty");
      const qtyValue = item.querySelector(".bundle-box__qty-value");
      const minusBtn = item.querySelector('[data-action="minus"]');
      const plusBtn = item.querySelector('[data-action="plus"]');

      // Keep item identity synced when native product-card selectors change
      item.querySelectorAll(".product-card-form select").forEach((select) => {
        select.addEventListener("change", () => {
          this.syncSelectedItemIdentity(item);
        });
      });

      if (addBtn) {
        addBtn.addEventListener("click", () => {
          if (addBtn.disabled || this.selectedCount >= this.limit) return;

          this.syncSelectedItemIdentity(item);

          item.classList.add("is-active");
          if (qtyWrap) qtyWrap.hidden = false;

          const id = item.dataset.itemId;
          const title = item.dataset.itemTitle || "Product";
          const imageSrc = item.dataset.imageSrc || "";
          const imageAlt = item.dataset.imageAlt || "";

          const existing = this.selectedItems.get(id);
          if (existing) {
            existing.qty += 1;
            existing.title = title;
            existing.imageSrc = imageSrc;
            existing.imageAlt = imageAlt;
          } else {
            this.selectedItems.set(id, { title, imageSrc, imageAlt, qty: 1 });
          }

          this.selectedCount += 1;
          if (qtyValue) qtyValue.textContent = String(this.selectedItems.get(id).qty);

          this.renderPickedList();
          this.updateUI();
        });
      }

      if (minusBtn) {
        minusBtn.addEventListener("click", () => {
          this.syncSelectedItemIdentity(item);

          const id = item.dataset.itemId;
          const existing = this.selectedItems.get(id);
          if (!existing) return;

          existing.qty -= 1;
          this.selectedCount = Math.max(0, this.selectedCount - 1);

          if (existing.qty <= 0) {
            this.selectedItems.delete(id);
            item.classList.remove("is-active");
            if (qtyWrap) qtyWrap.hidden = true;
            if (qtyValue) qtyValue.textContent = "1";
          } else if (qtyValue) {
            qtyValue.textContent = String(existing.qty);
          }

          this.renderPickedList();
          this.updateUI();
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener("click", () => {
          if (this.selectedCount >= this.limit) return;

          this.syncSelectedItemIdentity(item);

          const id = item.dataset.itemId;
          const existing = this.selectedItems.get(id);
          if (!existing) return;

          existing.qty += 1;
          this.selectedCount += 1;
          if (qtyValue) qtyValue.textContent = String(existing.qty);

          this.renderPickedList();
          this.updateUI();
        });
      }
    });
  }

  getItemVariantId(item) {
    const formIdInput = item.querySelector('.product-card-form form [name="id"]');
    if (formIdInput && formIdInput.value) return formIdInput.value;

    const variantSelect = item.querySelector('.product-card-form select[name="id"]');
    if (variantSelect && variantSelect.value) return variantSelect.value;

    return item.dataset.itemId || "";
  }

  getItemTitle(item) {
    const titleNode = item.querySelector(".product-card-link span");
    if (titleNode && titleNode.textContent.trim().length) {
      return titleNode.textContent.trim();
    }
    return item.dataset.itemTitle || "Product";
  }

  getItemImageData(item) {
    const image = item.querySelector(".product-card .img-wrapper img");
    return {
      src: image?.getAttribute("src") || item.dataset.imageSrc || "",
      alt: image?.getAttribute("alt") || item.dataset.imageAlt || ""
    };
  }

  syncSelectedItemIdentity(item) {
    const oldId = item.dataset.itemId || "";
    const newId = this.getItemVariantId(item);
    const newTitle = this.getItemTitle(item);
    const newImage = this.getItemImageData(item);

    if (!newId) return;

    item.dataset.itemId = newId;
    item.dataset.itemTitle = newTitle;
    item.dataset.imageSrc = newImage.src;
    item.dataset.imageAlt = newImage.alt;

    // If item already selected, move/update map entry to new variant id
    if (oldId && oldId !== newId && this.selectedItems.has(oldId)) {
      const existing = this.selectedItems.get(oldId);
      this.selectedItems.delete(oldId);
      this.selectedItems.set(newId, {
        title: newTitle,
        imageSrc: newImage.src,
        imageAlt: newImage.alt,
        qty: existing.qty
      });

      const qtyValue = item.querySelector(".bundle-box__qty-value");
      if (qtyValue) qtyValue.textContent = String(existing.qty);

      this.renderPickedList();
      this.updateUI();
      return;
    }

    if (this.selectedItems.has(newId)) {
      const current = this.selectedItems.get(newId);
      current.title = newTitle;
      current.imageSrc = newImage.src;
      current.imageAlt = newImage.alt;
      this.renderPickedList();
    }
  }

  renderPickedList() {
    if (!this.pickedList || !this.emptyState) return;

    this.pickedList.innerHTML = "";

    if (this.selectedItems.size === 0) {
      this.emptyState.hidden = false;
      return;
    }

    this.emptyState.hidden = true;

    for (const [id, item] of this.selectedItems.entries()) {
      const row = document.createElement("div");
      row.className = "bundle-box__picked-item";
      row.dataset.itemId = id;

      const left = document.createElement("div");
      left.className = "bundle-box__picked-left";

      if (item.imageSrc) {
        const img = document.createElement("img");
        img.className = "bundle-box__picked-image";
        img.src = item.imageSrc;
        img.alt = item.imageAlt || "";
        left.appendChild(img);
      }

      const title = document.createElement("p");
      title.className = "bundle-box__picked-title";
      title.textContent = item.title;
      left.appendChild(title);

      const right = document.createElement("div");
      right.className = "bundle-box__picked-right";

      const count = document.createElement("span");
      count.textContent = `x${item.qty}`;
      right.appendChild(count);

      const remove = document.createElement("button");
      remove.type = "button";
      remove.className = "bundle-box__picked-remove";
      remove.setAttribute("aria-label", "Remove");
      remove.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>`;
      remove.addEventListener("click", () => {
        this.removeItem(id);
      });

      right.appendChild(remove);
      row.appendChild(left);
      row.appendChild(right);

      this.pickedList.appendChild(row);
    }

    this.updateProductsProperty();
  }

  removeItem(id) {
    const existing = this.selectedItems.get(id);
    if (!existing) return;

    this.selectedCount = Math.max(0, this.selectedCount - existing.qty);
    this.selectedItems.delete(id);

    this.items.forEach((item) => {
      if (item.dataset.itemId !== id) return;

      item.classList.remove("is-active");
      const qtyWrap = item.querySelector(".bundle-box__qty");
      const qtyValue = item.querySelector(".bundle-box__qty-value");
      if (qtyWrap) qtyWrap.hidden = true;
      if (qtyValue) qtyValue.textContent = "1";
    });

    this.renderPickedList();
    this.updateUI();
  }

  updateProductsProperty() {
    if (!this.productsPropertyInput) return;

    const value = Array.from(this.selectedItems.values())
      .map((item) => `${item.title} (x${item.qty})`)
      .join(", ");

    this.productsPropertyInput.value = value;
  }

  updateUI() {
    if (this.statusEl) {
      this.statusEl.textContent = `${this.selectedCount}/${this.limit} ${this.statusLabel}`;
    }

    const canSubmit = this.limit > 0 && this.selectedCount === this.limit;
    if (this.submitButton) this.submitButton.disabled = !canSubmit;

    this.items.forEach((item) => {
      const addBtn = item.querySelector(".bundle-box__add-btn");
      const plusBtn = item.querySelector('[data-action="plus"]');
      const active = item.classList.contains("is-active");
      const hitLimit = this.selectedCount >= this.limit;

      if (addBtn && !active && !addBtn.classList.contains("out-of-stock")) {
        addBtn.disabled = hitLimit;
      }

      if (plusBtn) {
        plusBtn.disabled = hitLimit || !active;
      }
    });

    this.updateProductsProperty();
  }

  bindSubmit() {
    if (!this.form) return;
    this.form.addEventListener("submit", this.onSubmit);
  }

  async onSubmit(event) {
    const cartComponent = document.querySelector("cart-component");
    if (!cartComponent) return;

    event.preventDefault();

    if (this.submitButton?.disabled) return;

    const formData = new FormData(this.form);
    const cartDrawerSectionId = cartComponent.dataset.sectionId || "cart-drawer";
    formData.set("sections", `cart-badge,${cartDrawerSectionId}`);
    formData.set("sections_url", window.location.pathname);

    this.submitButton.classList.add("loading");
    this.submitButton.disabled = true;
    this.submitButton.setAttribute("aria-busy", "true");

    try {
      await cartComponent.add(formData);
    } finally {
      this.submitButton.classList.remove("loading");
      this.submitButton.setAttribute("aria-busy", "false");
      this.updateUI();
    }
  }
}

if (!customElements.get("bundle-box")) {
  customElements.define("bundle-box", BundleBox);
}